





















































































































































































/* General */
import Vue from 'vue'
import RegistrationLayout from '@/layouts/registration-layout.vue'
import MainContainer from '@/layouts/main-container.vue'

import doneDoneLogoSrc from '@/assets/img/logos/logo-donedone.svg'
import heartImgSrc from '@/assets/img/heart.svg'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { IRegistrationOutputExistingMembershipInfo } from '@/api/types/response.types'

/* API */
import RegistrationAPI from '@/api/modules/registration.api'

export default Vue.extend({
  name: 'AccountRegistrationUsher',

  metaInfo(): any {
    return {
      title: 'Account registration',
    }
  },

  components: {
    RegistrationLayout,
    MainContainer,
  },

  data() {
    return {
      doneDoneLogo: {
        src: doneDoneLogoSrc,
        alt: 'DoneDone logo',
      },
      heartImg: {
        src: heartImgSrc,
        alt: 'heart',
      },
      RouteAssistant,
      isLoading: true,
      requestingTrialExtension: false,
      cancellingOldExpiredTrials: false,
      expiredTrialExtensionRequested: false,
      tokenErrorMessage: '',
      existingMembershipInfo: {
        listActiveAccountMembershipNames: [] as string[],
      } as IRegistrationOutputExistingMembershipInfo,
    }
  },

  computed: {
    unregistered(): boolean {
      return !this.existingMembershipInfo.hasUserRegistered
    },
    autoUsherToAccountComplete(): boolean {
      const noOwnedSuspendedAccountsNorActiveMemberships =
        !this.existingMembershipInfo.hasMembershipToActiveAccount &&
        !this.ownsSuspendedAccounts

      return noOwnedSuspendedAccountsNorActiveMemberships
    },
    ownsSuspendedAccounts(): boolean {
      return (
        this.existingMembershipInfo.isOwnerOfExpiredTrial ||
        this.existingMembershipInfo.isOwnerOfPaidSuspendedAccount
      )
    },
    belongsToActiveAccount(): boolean {
      return (
        this.existingMembershipInfo.listActiveAccountMembershipNames.length > 0
      )
    },
    belongsToExactlyOneActiveAccount(): boolean {
      return (
        this.existingMembershipInfo.listActiveAccountMembershipNames.length ===
        1
      )
    },
    belongsToMultipleActiveAccounts(): boolean {
      return (
        this.existingMembershipInfo.listActiveAccountMembershipNames.length > 1
      )
    },
    firstActiveAccountName(): string {
      return this.existingMembershipInfo.listActiveAccountMembershipNames[0]
    },
    hasTokenErrorMessage(): boolean {
      return (
        this.tokenErrorMessage !== undefined &&
        this.tokenErrorMessage.length > 0
      )
    },
    ddToken(): string {
      return TextAssistant.urlTokenCleaner(this.$route.query.donedone_token)
    },
    gAuthToken(): string {
      return TextAssistant.urlTokenCleaner(this.$route.query.gauth_token)
    },
    gl(): string {
      return this.$route.query._gl
    },
  },

  async created() {
    this.isLoading = true
    await this.getExistingMembershipInfo()
    this.isLoading = false
  },

  methods: {
    async requestTrialExtension() {
      try {
        this.requestingTrialExtension = true
        await RegistrationAPI.get_ExpiredTrialExtension(
          this.ddToken,
          this.gAuthToken,
        )
        this.expiredTrialExtensionRequested = true
      } catch (error) {
        this.$error.emit(error, true)
      } finally {
        this.requestingTrialExtension = false
      }
    },
    async cancelOldExpiredTrialAndSignupAgain() {
      try {
        this.cancellingOldExpiredTrials = true
        await RegistrationAPI.post_OldExpiredTrialCancellation({
          donedoneToken: this.ddToken,
          gauthToken: this.gAuthToken,
        })
      } finally {
        // Call membership info again and it should usher to account complete...
        await this.getExistingMembershipInfo()
        this.cancellingOldExpiredTrials = false
      }
    },
    async getExistingMembershipInfo() {
      try {
        this.existingMembershipInfo = await RegistrationAPI.get_ExistingMembershipInfo(
          this.ddToken,
          this.gAuthToken,
        )
      } catch (error) {
        // For any errors, just pass this along to the account complete for handling
        // (e.g. bad / expired token will be error-handled on account complete GET,
        // No user exists on previous call will become a normal new signup)
      } finally {
        if (this.autoUsherToAccountComplete) {
          // Go to complete....
          RouteAssistant.goToAccountRegistrationComplete(
            this.$router,
            this.ddToken,
            this.gAuthToken,
            this.gl,
          )
        }
      }
    },
  },
})
